module.exports = __webpack_public_path__ + "static/media/icon-nav-settings.33a25eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-settings.svg
// module id = 1217
// module chunks = 19